import { FormattedMessage } from 'dibs-react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { hideRotateBanner as hideRotateBannerDispatch } from '../actionCreators/uiActionCreators';
import ArrowClockwiseIcon from 'dibs-icons/exports/legacy/ArrowClockwise';
import CloseIcon from 'dibs-icons/exports/legacy/Close';
import { CONTAINER_WIDTH_TABLET } from '../catalogConstants';
import { isMobilePortrait } from '../catalogHelpers';
import styles from '../styles/catalogHeader.scss';
import { Link } from 'dibs-elements/exports/Link';

export const CatalogHeaderComponent = ({
    deviceType,
    hideRotateBanner,
    screenOrientation,
    showRotateBanner,
    title,
}) => {
    const isPhonePortrait = isMobilePortrait(deviceType, screenOrientation);
    const breadcrumbClassNames = classNames(styles.breadcrumb, {
        [styles.breadcrumbMobile]: isPhonePortrait,
    });

    const homeTitle = (
        <Link className={breadcrumbClassNames} href="/">
            <FormattedMessage id="CatalogHeader.home" defaultMessage="Home" />
        </Link>
    );
    const catalogsTitle = (
        <Link className={breadcrumbClassNames} href="/shop/catalogs/">
            <FormattedMessage id="CatalogHeader.catalogs" defaultMessage="Catalogs" />
        </Link>
    );

    return (
        <div
            className={classNames({
                [styles.titleContainerMobilePortrait]: isPhonePortrait,
                [styles.titleContainerNonMobilePortrait]: !isPhonePortrait,
            })}
        >
            <div className={styles.breadcrumbs}>
                {homeTitle} / {catalogsTitle}
                <div className={breadcrumbClassNames}>{title ? ` / ${title}` : ''}</div>
            </div>
            <div className={styles.pdfTitle}>{title}</div>
            {showRotateBanner && (
                <div
                    data-tn="rotate-screen-banner"
                    className={styles.rotateScreenBanner}
                    style={{ width: CONTAINER_WIDTH_TABLET + 'px' }}
                >
                    <ArrowClockwiseIcon className={styles.rotateScreenBannerArrowIcon} />
                    <div className={styles.rotateScreenBannerText}>
                        For the most optimal viewing experience, rotate your device.
                    </div>
                    <div onClick={hideRotateBanner} className={styles.rotateScreenBannerCloseIcon}>
                        <CloseIcon />
                    </div>
                </div>
            )}
        </div>
    );
};

CatalogHeaderComponent.propTypes = {
    deviceType: PropTypes.string,
    hideRotateBanner: PropTypes.func,
    screenOrientation: PropTypes.string,
    showRotateBanner: PropTypes.bool,
    title: PropTypes.string,
};

const mapStateToProps = state => {
    return {
        screenOrientation: state.ui.screenOrientation,
        showRotateBanner: state.ui.showRotateBanner,
    };
};

export const mapDispatchToProps = dispatch => {
    return {
        hideRotateBanner: () => dispatch(hideRotateBannerDispatch()),
    };
};

export const CatalogHeader = connect(mapStateToProps, mapDispatchToProps)(CatalogHeaderComponent);
